<template>
    <div class="sheet" @click.stop="onClose" @scroll.stop>
        <div class="main" :class="{close: isClose}" @click.stop>
            <div class="header">
                <div class="cancel" @click="onCancel">
                    <span>取消</span>
                </div>
                <div class="title">
                    任務開始時間
                </div>
                <div class="confirm" @click="onConfirm">
                    <span>確定</span>
                </div>
            </div>
            <div class="description">抵達起點的時間</div>
            <div class="content">
                <smooth-picker class="picker" ref="picker" :data="data" :change="onChange"/>
            </div>
        </div>
    </div>
</template>

<script>
    import BottomSheet from '../BottomSheet';
    import mTimezone from 'moment-timezone';
    import moment from 'moment';

    export default {
        name: 'SetOrderTime',
        components: {
            'bottom-sheet': BottomSheet,
        },
        props: {
            dates: {
                default: {},
                required: true
            },
            selected: {
                default: '',
            }
        },
        data() {
            return {
                today: null,
                tomorrow: null,
                afterTomorrow: null,
                dayIndex: 0,
                timeIndex: 0,
                isClose: false,
            };
        },
        computed: {
            data() {
                return [
                    {
                        currentIndex: this.dayIndex,
                        flex: 2,
                        list: this.days,
                        textAlign: 'center',
                    },
                    {
                        currentIndex: this.timeIndex,
                        flex: 2,
                        list: this.times,
                        textAlign: 'center',
                    }
                ]
            },
            days() {
                let days =  Object.keys(this.dates).map(key => {
                    let date = moment(key);
                    let title = '';
                    if (date.isSame(this.today, 'day')) {
                        title = '今天，';
                    }

                    if (date.isSame(this.tomorrow, 'day')) {
                        title = '明天，';
                    }

                    if (date.isSame(this.afterTomorrow, 'day')) {
                        title = '後天，';
                    }

                    return {
                        date: key,
                        value: title + date.format('MM/DD'),
                        isToDay: date.isSame(this.today, 'day')
                    }
                });

                if (! days.length) {
                    days = [{date: this.today.format('YYYY-MM-DD'), value: this.today.format('今天，MM/DD'), isToDay: true}]
                }

                return days;
            },
            times() {
                let day = this.days[this.dayIndex] || this.days[this.days.length - 1];

                let date = this.dates[day.date] || [];
                let times = date.map(time => {
                    time = moment(time);
                    return {
                        date: time.format('HH:mm'),
                        value: time.format('HH:mm'),
                    }
                });

                if (moment(day.date).isSame(this.today, 'day')) {
                    times = [{date: 'now', value: '馬上出發'}].concat(times);
                }

                return times;
            },
        },
        methods: {
            init() {
                let timezone = mTimezone().tz('Asia/Taipei');
                this.today = moment(timezone);
                this.tomorrow = this.today.clone().add(1, 'days');
                this.afterTomorrow = this.today.clone().add(2, 'days');

                if (this.selected) {
                    let time = this.selected.split(' ');

                    let di = this.days.findIndex(day => {
                        return day.date === time[0];
                    });
                    if (di >= 0) this.dayIndex = di;

                    let ti = this.times.findIndex(t => {
                        return t.date === time[1].slice(0,5);
                    });
                    if (ti >= 0) this.timeIndex = ti;
                }
            },
            onCancel() {
                this.$emit('onDone', null, null);
            },
            onConfirm() {
                let ciList = this.$refs.picker.getCurrentIndexList();
                this.dayIndex = ciList[0];
                this.timeIndex = ciList[1];

                let day = this.days[this.dayIndex];
                let time = this.times[this.timeIndex].date;
                this.$emit('onDone', day, time);
            },
            onClose() {
                this.isClose = true;
                this.$emit('onDone', null, null);
            },
            onChange() {
                let ciList = this.$refs.picker.getCurrentIndexList();
                let oldTime = this.times[ciList[1]];

                this.dayIndex = ciList[0];
                let newTimeIndex = this.times.findIndex(time => {
                    return time.date === oldTime.date;
                });

                if (newTimeIndex >= 0) {
                    this.timeIndex = newTimeIndex;
                } else if (this.times.length && this.times[0].date === 'now') {
                    this.timeIndex = 0;
                } else {
                    this.timeIndex = Math.max(Math.floor(this.times.length / 2), 0);
                }

                this.$refs.picker.setGroupData(1, this.data[1]);
            },
        },
        created() {
            this.init();
        },
    };
</script>

<style lang="scss" scoped>
    .picker {
        .smooth-middle {
            height: 2.5em !important;
        }
    }

    .sheet {
        background-color: rgba(0,0,0,0.4);
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 10;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .main {
        border-radius: 10px;
        background-color: rgba(255,255,255,1);
        padding: 25px 15px;
        margin: 20px;
        transition: 0.2s cubic-bezier(0.25, 0.8, 0.25, 1);

        &.close {
            bottom: -100%;
        }

        .header {
            display: flex;
            justify-content: space-between;
            margin: 0 5px;
            font-size: 16px;
            line-height: 22px;

            .cancel {
                color: rgba(155,155,155,1);
                cursor: pointer;
            }

            .confirm {
                color: rgba(51,153,51,1);
                cursor: pointer;
            }

            .title {
                color: rgba(0,0,0,1);
                font-weight: 500;
            }
        }

        .content {
            margin-top: 20px;
        }

        .description {
            color: rgba(120,120,120,1);
            font-size: 12px;
            line-height: 17px;
            text-align: center;
        }
    }
</style>